module.exports = __webpack_public_path__ + "static/media/remedios.c5f33dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/remedios.png
// module id = 63
// module chunks = 0